import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { PM_HOME_ROUTE, pmMayOpenRoute } from '../../../src/services/team/roles';

interface Props {
  children: ReactNode;
  /** Only admins may open this route (Settings › Team). */
  adminOnly?: boolean;
}

export function AuthGuard({ children, adminOnly = false }: Props): JSX.Element {
  const { user, loading, role, deactivated } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="ari-app" style={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
        <div className="spinner dark" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (deactivated) return <AccessOff />;
  // Project Managers use SOWs only; the API and RLS enforce the same scope.
  if (role === 'pm' && !pmMayOpenRoute(location.pathname)) return <Navigate to={PM_HOME_ROUTE} replace />;
  if (adminOnly && role !== 'admin') return <Navigate to="/settings" replace />;
  return <>{children}</>;
}

function AccessOff(): JSX.Element {
  const { signOut } = useAuth();
  return (
    <div className="ari-app">
      <div className="login-page">
        <div className="login-card">
          <div className="login-brand">
            <span className="dot" />
            <span>Ariel Operations Reports</span>
          </div>
          <h1 className="login-h">Your access is off</h1>
          <div className="login-sub">
            An admin turned off your access to the Operations Dashboard. Ask them to restore it if you still need it.
          </div>
          <button type="button" className="btn btn-secondary" onClick={() => void signOut()}>Sign out</button>
        </div>
      </div>
    </div>
  );
}
